import { Box, Button, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { Api } from '@/constants';
import type { Lesson } from '@/data/eduplay/interfaces';
import { useLessons } from '@/packages/eduplay/context/lessons';
import { useGenerateCertificate } from '@/packages/eduplay/hooks';
import { LessonItem } from '@/packages/eduplay/pages/course/components/lesson-item';

const downloadFile = (content: string, filename: string) => {
  const encodedUri = encodeURI(content);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `${filename}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const VideoLessonsList = () => {
  const {
    lessons,
    courseName,
    currentLessonId,
    courseId,
    setCurrentCourseLesson,
    hasFiles,
    isCompleted,
  } = useLessons();
  const { viewCertificate, loadingCertificate } = useGenerateCertificate(
    courseId!
  );

  const handleLessonClick = (lesson: Lesson) => {
    setCurrentCourseLesson?.(lesson.id);
  };

  const downloadContents = () => {
    downloadFile(
      `${Api.EdupassApi}/cursos/${courseId}/get-files`,
      `Material complementar - ${courseName}`
    );
  };

  return (
    <ContentBox spacing={2}>
      <Typography variant="h2">{courseName}</Typography>
      {isCompleted && (
        <Button
          variant="contained"
          onClick={viewCertificate}
          loading={loadingCertificate}
        >
          {loadingCertificate ? 'Gerando certificado...' : 'Ver certificado'}
        </Button>
      )}
      {hasFiles && (
        <Button variant="outlined" onClick={downloadContents}>
          Baixar material complementar
        </Button>
      )}
      <Box>
        <Typography variant="h3">Aulas</Typography>
        <Stack sx={{ overflow: 'auto', height: '286px' }}>
          {lessons?.map((lesson) => (
            <Box key={lesson.id}>
              <LessonItem
                key={lesson.id}
                lesson={lesson}
                isCurrent={currentLessonId === lesson.id}
                onClick={() => handleLessonClick(lesson)}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </ContentBox>
  );
};
